

import initmixin from "@/Services/initmixin";

export default {
 
  //mixins: [initmixin],
 // GET_CLIENTES CREAR_CLIENTES EDITAR_CLIENTES ELIMINAR_CLIENTES

 GET: async function( data){
      let url='/ordenes/?page='+data.page+'&search='+data.search
      return initmixin.formatrespuesta('get', data,url,true)
    },
    CREAR: async function( data) {
      let url='/ordenes/'
      return initmixin.formatrespuesta('post', data,url,true)
    },
    SHOW: async function( data) {
      let url='/ordenes/'+data.id
      return initmixin.formatrespuesta('get', data,url,true)
    },
    EDITAR: async function( data) {
      let url='/ordenes/'+data.id
      return initmixin.formatrespuesta('put', data,url,true)
    },
    SET_FECHA_LLEGADA: async function( data) {
      let url='/ordenes/'+data.id+'/llegada'
      return initmixin.formatrespuesta('put', data,url,true)
    },
    SET_FECHA_PEDIDO: async function( data) {
      let url='/ordenes/'+data.id+'/pedido'
      return initmixin.formatrespuesta('put', data,url,true)
    },
    SET_FECHA_PAGO: async function( data) {
      let url='/ordenes/'+data.id+'/pago'
      return initmixin.formatrespuesta('put', data,url,true)
    },
    
    ELIMINAR: async function( data) {
      let url='/ordenes/'+data.id
      return initmixin.formatrespuesta('delete', data,url,true)
    },
   


}